import { render, staticRenderFns } from "./ExperienceUi.vue?vue&type=template&id=35bffef4&scoped=true&"
import script from "./ExperienceUi.vue?vue&type=script&lang=js&"
export * from "./ExperienceUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bffef4",
  null
  
)

export default component.exports